module.exports = __webpack_public_path__ + "img/gerente_financeiro.984215f5.png";